/*
 * Fragrance Boutique
 * Renders the fragrance page from the JSON printed by sections/fragrance-boutique.liquid.
 * No dependencies. Works with Horizon cart events when they are available.
 */
(function () {
  'use strict';

  if (window.FragranceBoutique) {
    window.FragranceBoutique.initAll();
    return;
  }

  /* ---------------------------------------------------------------- utils */

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var DOT = ' \xB7 ';
  /* Comma, semicolon, new line, pipe and the Arabic comma (char code 1548). */
  var LIST_SPLIT = new RegExp('[,;\\n|' + String.fromCharCode(1548) + ']+');

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fold(value) {
    return String(value == null ? '' : value)
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .toLowerCase()
      .trim();
  }

  function keyOf(value) {
    return fold(value).replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ').trim();
  }

  function slugOf(value) {
    return keyOf(value).replace(/\s+/g, '-');
  }

  function splitList(value) {
    if (!value) return [];
    var list = Array.isArray(value) ? value : String(value).split(LIST_SPLIT);
    return list.map(function (x) { return String(x).trim(); }).filter(Boolean);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var fmt = format || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var match = fmt.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function genderKey(value) {
    var s = fold(value);
    if (!s) return '';
    if (/unisex|both|mixed|shared|للجنسين|للرجال والنساء|للنساء والرجال|مشترك/.test(s)) return 'unisex';
    if (/\b(her|women|woman|female|femme|ladies|lady)\b|للنساء|نسائي|نسائ|حريمي|سيدات|انث|^لها$/.test(s)) return 'her';
    if (/\b(him|men|man|male|homme|gents|gentleman)\b|للرجال|رجالي|رجال|للرجل|ذكور|ذكر|^له$/.test(s)) return 'him';
    return '';
  }

  function seasonKey(value) {
    var s = fold(value);
    if (!s) return '';
    if (/all|year|any|every|4 season|four season|طوال|العام|السنة|المواسم/.test(s)) return 'allyear';
    if (/summer|spring|hot|warm|صيف|ربيع|حار|دافئ/.test(s)) return 'summer';
    if (/winter|autumn|fall|cold|cool|شتاء|شتوي|خريف|بارد/.test(s)) return 'winter';
    return '';
  }

  function sizeParts(title) {
    var m = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*(ml|m\.l|oz|g|cl)\b/i);
    if (m) return { num: m[1], unit: m[2].toLowerCase().replace('.', '') };
    return { num: title, unit: '' };
  }

  /* ------------------------------------------------------------ note logic */

  /* Localized ingredient labels share canonical keys for the finder and similarity. */
  var NOTE_LABELS = {
  "Agarwood (Oud)": [
    "Agarwood (Oud)",
    "خشب العود",
    "🪵"
  ],
  "Akigalawood": [
    "Akigalawood",
    "أكيغالا وود",
    "🪵"
  ],
  "Aldehydes": [
    "Aldehydes",
    "الألدهيدات",
    "🫧"
  ],
  "Algae": [
    "Algae",
    "الطحالب البحرية",
    "🌿"
  ],
  "Almond": [
    "Almond",
    "اللوز",
    "🌰"
  ],
  "Amaretto": [
    "Amaretto",
    "أماريتو",
    "🥃"
  ],
  "Amber": [
    "Amber",
    "العنبر",
    "🟠"
  ],
  "Ambergris": [
    "Ambergris",
    "العنبر الرمادي",
    "🪨"
  ],
  "Ambermax": [
    "Ambermax",
    "أمبرماكس",
    "🟠"
  ],
  "Amberwood": [
    "Amberwood",
    "خشب العنبر",
    "🪵"
  ],
  "Ambrette": [
    "Ambrette",
    "بذور الأمبريت",
    "🌾"
  ],
  "Ambroxan": [
    "Ambroxan",
    "أمبروكسان",
    "🪨"
  ],
  "Animalic Notes": [
    "Animalic Notes",
    "نفحات حيوانية",
    "🤎"
  ],
  "Anise": [
    "Anise",
    "اليانسون",
    "🌿"
  ],
  "Apple": [
    "Apple",
    "التفاح",
    "🍎"
  ],
  "Apricot": [
    "Apricot",
    "المشمش",
    "🍑"
  ],
  "Australian Sandalwood": [
    "Australian Sandalwood",
    "خشب الصندل الأسترالي",
    "🪵"
  ],
  "Basil": [
    "Basil",
    "الريحان",
    "🌿"
  ],
  "Benzoin": [
    "Benzoin",
    "البنزوين",
    "🟤"
  ],
  "Bergamot": [
    "Bergamot",
    "البرغموت",
    "🍋"
  ],
  "Birch": [
    "Birch",
    "البتولا",
    "🪵"
  ],
  "Birch Woods": [
    "Birch Woods",
    "أخشاب البتولا",
    "🪵"
  ],
  "Bitter Almond": [
    "Bitter Almond",
    "اللوز المر",
    "🌰"
  ],
  "Bitter Orange": [
    "Bitter Orange",
    "البرتقال المر",
    "🍊"
  ],
  "Black Currant": [
    "Black Currant",
    "الكشمش الأسود",
    "🫐"
  ],
  "Black Pepper": [
    "Black Pepper",
    "الفلفل الأسود",
    "⚫"
  ],
  "Black Tea": [
    "Black Tea",
    "الشاي الأسود",
    "🍵"
  ],
  "Blood Orange": [
    "Blood Orange",
    "البرتقال الأحمر",
    "🍊"
  ],
  "Bourbon Vanilla": [
    "Bourbon Vanilla",
    "فانيليا بوربون",
    "🌼"
  ],
  "Broom": [
    "Broom",
    "زهور الجنيستا",
    "🌼"
  ],
  "Bulgarian Rose": [
    "Bulgarian Rose",
    "الورد البلغاري",
    "🌹"
  ],
  "Cacao": [
    "Cacao",
    "الكاكاو",
    "🍫"
  ],
  "Calabrian Bergamot": [
    "Calabrian Bergamot",
    "برغموت كالابريا",
    "🍋"
  ],
  "Cannabis": [
    "Cannabis",
    "القنب",
    "🌿"
  ],
  "Cappuccino": [
    "Cappuccino",
    "الكابتشينو",
    "☕"
  ],
  "Caramel": [
    "Caramel",
    "الكراميل",
    "🍮"
  ],
  "Cardamom": [
    "Cardamom",
    "الهيل",
    "🌿"
  ],
  "Carrot Seeds": [
    "Carrot Seeds",
    "بذور الجزر",
    "🥕"
  ],
  "Cashmeran": [
    "Cashmeran",
    "الكشميران",
    "🪵"
  ],
  "Cashmere Wood": [
    "Cashmere Wood",
    "خشب الكشمير",
    "🪵"
  ],
  "Cedar": [
    "Cedar",
    "الأرز",
    "🪵"
  ],
  "Cedarwood": [
    "Cedarwood",
    "خشب الأرز",
    "🪵"
  ],
  "Ceylon Cinnamon": [
    "Ceylon Cinnamon",
    "قرفة سيلان",
    "🟤"
  ],
  "Cherry": [
    "Cherry",
    "الكرز",
    "🍒"
  ],
  "Chinese Black Tea": [
    "Chinese Black Tea",
    "الشاي الأسود الصيني",
    "🍵"
  ],
  "Chinese Cedarwood": [
    "Chinese Cedarwood",
    "خشب الأرز الصيني",
    "🪵"
  ],
  "Cinnamon": [
    "Cinnamon",
    "القرفة",
    "🟤"
  ],
  "Cinnamon Leaf": [
    "Cinnamon Leaf",
    "أوراق القرفة",
    "🍃"
  ],
  "Cistus": [
    "Cistus",
    "اللادن",
    "🌿"
  ],
  "Cistus Absolute": [
    "Cistus Absolute",
    "خلاصة اللادن",
    "🌿"
  ],
  "Citron": [
    "Citron",
    "الأترج",
    "🍋"
  ],
  "Citrus": [
    "Citrus",
    "الحمضيات",
    "🍋"
  ],
  "Clary Sage": [
    "Clary Sage",
    "الميرمية المتصلبة",
    "🌿"
  ],
  "Clove": [
    "Clove",
    "القرنفل",
    "🟤"
  ],
  "Coconut": [
    "Coconut",
    "جوز الهند",
    "🥥"
  ],
  "Coconut Milk": [
    "Coconut Milk",
    "حليب جوز الهند",
    "🥥"
  ],
  "Coffee": [
    "Coffee",
    "القهوة",
    "☕"
  ],
  "Cognac": [
    "Cognac",
    "الكونياك",
    "🥃"
  ],
  "Coriander": [
    "Coriander",
    "الكزبرة",
    "🌿"
  ],
  "Coumarin": [
    "Coumarin",
    "الكومارين",
    "🌾"
  ],
  "Cumin": [
    "Cumin",
    "الكمون",
    "🌾"
  ],
  "Cyclamen": [
    "Cyclamen",
    "بخور مريم",
    "🌸"
  ],
  "Cypriol": [
    "Cypriol",
    "السيبريول",
    "🌾"
  ],
  "Damask Rose": [
    "Damask Rose",
    "الورد الدمشقي",
    "🌹"
  ],
  "Dates": [
    "Dates",
    "التمر",
    "🟤"
  ],
  "Davana": [
    "Davana",
    "الدافانا",
    "🌿"
  ],
  "Dried Fruits": [
    "Dried Fruits",
    "الفواكه المجففة",
    "🍇"
  ],
  "Durian": [
    "Durian",
    "الدوريان",
    "🍈"
  ],
  "Elemi": [
    "Elemi",
    "راتنج الإليمي",
    "🟡"
  ],
  "Fig": [
    "Fig",
    "التين",
    "🍃"
  ],
  "Fir": [
    "Fir",
    "التنوب",
    "🌲"
  ],
  "Frankincense": [
    "Frankincense",
    "اللبان",
    "🟡"
  ],
  "Freesia": [
    "Freesia",
    "الفريزيا",
    "🌸"
  ],
  "Geranium": [
    "Geranium",
    "إبرة الراعي",
    "🌸"
  ],
  "Ginger": [
    "Ginger",
    "الزنجبيل",
    "🫚"
  ],
  "Grapefruit": [
    "Grapefruit",
    "الجريب فروت",
    "🍊"
  ],
  "Green Mandarin": [
    "Green Mandarin",
    "اليوسفي الأخضر",
    "🍊"
  ],
  "Green Notes": [
    "Green Notes",
    "نفحات خضراء",
    "🍃"
  ],
  "Guaiac Wood": [
    "Guaiac Wood",
    "خشب الغاياك",
    "🪵"
  ],
  "Guatemalan Cardamom": [
    "Guatemalan Cardamom",
    "الهيل الغواتيمالي",
    "🌿"
  ],
  "Gurjan Balsam": [
    "Gurjan Balsam",
    "بلسم الغورجون",
    "🟤"
  ],
  "Haitian Vetiver": [
    "Haitian Vetiver",
    "نجيل الهند الهايتي",
    "🌾"
  ],
  "Hazelnut": [
    "Hazelnut",
    "البندق",
    "🌰"
  ],
  "Hedione": [
    "Hedione",
    "الهيديون",
    "🌼"
  ],
  "Heliotrope": [
    "Heliotrope",
    "الهليوتروب",
    "🌸"
  ],
  "Hibiscus": [
    "Hibiscus",
    "الكركديه",
    "🌺"
  ],
  "Honey": [
    "Honey",
    "العسل",
    "🍯"
  ],
  "Ice": [
    "Ice",
    "الثلج",
    "🧊"
  ],
  "Immortelle": [
    "Immortelle",
    "زهرة الخلود",
    "🌼"
  ],
  "Incense": [
    "Incense",
    "البخور",
    "🟤"
  ],
  "Indian Amber": [
    "Indian Amber",
    "العنبر الهندي",
    "🟠"
  ],
  "Indian Oud": [
    "Indian Oud",
    "العود الهندي",
    "🪵"
  ],
  "Indonesian Patchouli": [
    "Indonesian Patchouli",
    "الباتشولي الإندونيسي",
    "🌿"
  ],
  "Iranian Saffron": [
    "Iranian Saffron",
    "الزعفران الإيراني",
    "🌺"
  ],
  "Iris": [
    "Iris",
    "السوسن",
    "🪻"
  ],
  "Iso E Super": [
    "Iso E Super",
    "آيزو إي سوبر",
    "🪵"
  ],
  "Italian Lemon": [
    "Italian Lemon",
    "الليمون الإيطالي",
    "🍋"
  ],
  "Jasmine": [
    "Jasmine",
    "الياسمين",
    "🌼"
  ],
  "Jasmine Sambac": [
    "Jasmine Sambac",
    "الياسمين العربي",
    "🌼"
  ],
  "Labdanum": [
    "Labdanum",
    "راتنج اللادن",
    "🟤"
  ],
  "Lavender": [
    "Lavender",
    "اللافندر",
    "🪻"
  ],
  "Leather": [
    "Leather",
    "الجلد",
    "🤎"
  ],
  "Leather Accord": [
    "Leather Accord",
    "نفحات الجلد",
    "🤎"
  ],
  "Lemon": [
    "Lemon",
    "الليمون",
    "🍋"
  ],
  "Licorice": [
    "Licorice",
    "عرق السوس",
    "🟤"
  ],
  "Lilac": [
    "Lilac",
    "الليلك",
    "🪻"
  ],
  "Lily": [
    "Lily",
    "الزنبق",
    "🌼"
  ],
  "Lily-of-the-Valley": [
    "Lily-of-the-Valley",
    "زنبق الوادي",
    "🌼"
  ],
  "Lime": [
    "Lime",
    "الليمون الأخضر",
    "🍋‍🟩"
  ],
  "Linden Blossom": [
    "Linden Blossom",
    "زهر الزيزفون",
    "🌼"
  ],
  "Lotus": [
    "Lotus",
    "اللوتس",
    "🪷"
  ],
  "Madagascar Vanilla": [
    "Madagascar Vanilla",
    "فانيليا مدغشقر",
    "🌼"
  ],
  "Magnolia": [
    "Magnolia",
    "الماغنوليا",
    "🌸"
  ],
  "Magnolia Accord": [
    "Magnolia Accord",
    "نفحات الماغنوليا",
    "🌸"
  ],
  "Mandarin Orange": [
    "Mandarin Orange",
    "اليوسفي",
    "🍊"
  ],
  "Mango": [
    "Mango",
    "المانجو",
    "🥭"
  ],
  "Marine Notes": [
    "Marine Notes",
    "نفحات بحرية",
    "🌊"
  ],
  "Marshmallow": [
    "Marshmallow",
    "المارشميلو",
    "☁️"
  ],
  "May Rose": [
    "May Rose",
    "ورد مايو",
    "🌹"
  ],
  "Milk": [
    "Milk",
    "الحليب",
    "🥛"
  ],
  "Mint": [
    "Mint",
    "النعناع",
    "🌿"
  ],
  "Moss": [
    "Moss",
    "الطحلب",
    "🌿"
  ],
  "Musk": [
    "Musk",
    "المسك",
    "🤍"
  ],
  "Myrrh": [
    "Myrrh",
    "المر",
    "🟤"
  ],
  "Myrtle": [
    "Myrtle",
    "الآس",
    "🌿"
  ],
  "Mystikal": [
    "Mystikal",
    "ميستيكال",
    "🟤"
  ],
  "Nigerian Ginger": [
    "Nigerian Ginger",
    "الزنجبيل النيجيري",
    "🫚"
  ],
  "Nutmeg": [
    "Nutmeg",
    "جوزة الطيب",
    "🌰"
  ],
  "Oak": [
    "Oak",
    "البلوط",
    "🌳"
  ],
  "Oakmoss": [
    "Oakmoss",
    "طحلب البلوط",
    "🌿"
  ],
  "Olibanum": [
    "Olibanum",
    "لبان الذكر",
    "🟡"
  ],
  "Opoponax": [
    "Opoponax",
    "الأوبوبوناكس",
    "🟤"
  ],
  "Orange": [
    "Orange",
    "البرتقال",
    "🍊"
  ],
  "Orange Blossom": [
    "Orange Blossom",
    "زهر البرتقال",
    "🌼"
  ],
  "Orcanox": [
    "Orcanox",
    "أوركانوكس",
    "🪨"
  ],
  "Orchid": [
    "Orchid",
    "الأوركيد",
    "🌸"
  ],
  "Orris": [
    "Orris",
    "جذور السوسن",
    "🪻"
  ],
  "Osmanthus": [
    "Osmanthus",
    "الأوسمانثوس",
    "🌼"
  ],
  "Osmanthus Absolute": [
    "Osmanthus Absolute",
    "خلاصة الأوسمانثوس",
    "🌼"
  ],
  "Oud": [
    "Oud",
    "العود",
    "🪵"
  ],
  "Ozonic Notes": [
    "Ozonic Notes",
    "نفحات أوزونية",
    "🫧"
  ],
  "Palisander Rosewood": [
    "Palisander Rosewood",
    "خشب الورد البلسندر",
    "🪵"
  ],
  "Papyrus": [
    "Papyrus",
    "ورق البردي",
    "🌾"
  ],
  "Passionfruit": [
    "Passionfruit",
    "الباشن فروت",
    "🟡"
  ],
  "Patchouli": [
    "Patchouli",
    "الباتشولي",
    "🌿"
  ],
  "Peach": [
    "Peach",
    "الخوخ",
    "🍑"
  ],
  "Pear": [
    "Pear",
    "الكمثرى",
    "🍐"
  ],
  "Peony": [
    "Peony",
    "الفاوانيا",
    "🌸"
  ],
  "Pepper": [
    "Pepper",
    "الفلفل",
    "🟤"
  ],
  "Peppermint": [
    "Peppermint",
    "النعناع الفلفلي",
    "🌿"
  ],
  "Petitgrain": [
    "Petitgrain",
    "البيتيغرين",
    "🍃"
  ],
  "Pineapple": [
    "Pineapple",
    "الأناناس",
    "🍍"
  ],
  "Pink Lotus": [
    "Pink Lotus",
    "اللوتس الوردي",
    "🪷"
  ],
  "Pink Pepper": [
    "Pink Pepper",
    "الفلفل الوردي",
    "🔴"
  ],
  "Plum": [
    "Plum",
    "البرقوق",
    "🟣"
  ],
  "Pomegranate": [
    "Pomegranate",
    "الرمان",
    "🔴"
  ],
  "Praline": [
    "Praline",
    "البرالين",
    "🍫"
  ],
  "Precious Woods": [
    "Precious Woods",
    "الأخشاب الثمينة",
    "🪵"
  ],
  "Raspberry": [
    "Raspberry",
    "توت العليق",
    "🍓"
  ],
  "Red Berries": [
    "Red Berries",
    "التوت الأحمر",
    "🍓"
  ],
  "Resins": [
    "Resins",
    "الراتنجات",
    "🟤"
  ],
  "Rhubarb": [
    "Rhubarb",
    "الراوند",
    "🌿"
  ],
  "Rose": [
    "Rose",
    "الورد",
    "🌹"
  ],
  "Rose Accord": [
    "Rose Accord",
    "نفحات الورد",
    "🌹"
  ],
  "Rosemary": [
    "Rosemary",
    "إكليل الجبل",
    "🌿"
  ],
  "Rum": [
    "Rum",
    "الروم",
    "🥃"
  ],
  "Saffron": [
    "Saffron",
    "الزعفران",
    "🌺"
  ],
  "Sage": [
    "Sage",
    "الميرمية",
    "🌿"
  ],
  "Salt": [
    "Salt",
    "الملح",
    "🧂"
  ],
  "Sandalwood": [
    "Sandalwood",
    "خشب الصندل",
    "🪵"
  ],
  "Sea Notes": [
    "Sea Notes",
    "نفحات البحر",
    "🌊"
  ],
  "Sea Water": [
    "Sea Water",
    "ماء البحر",
    "🌊"
  ],
  "Sesame": [
    "Sesame",
    "السمسم",
    "🌾"
  ],
  "Siam Benzoin": [
    "Siam Benzoin",
    "بنزوين سيام",
    "🟤"
  ],
  "Sichuan Pepper": [
    "Sichuan Pepper",
    "فلفل سيتشوان",
    "🟤"
  ],
  "Sicilian Bergamot": [
    "Sicilian Bergamot",
    "برغموت صقلية",
    "🍋"
  ],
  "Sicilian Orange": [
    "Sicilian Orange",
    "برتقال صقلية",
    "🍊"
  ],
  "Smoke": [
    "Smoke",
    "الدخان",
    "☁️"
  ],
  "Solar Notes": [
    "Solar Notes",
    "نفحات شمسية",
    "☀️"
  ],
  "Spices": [
    "Spices",
    "التوابل",
    "🟤"
  ],
  "Spicy Notes": [
    "Spicy Notes",
    "نفحات التوابل",
    "🟤"
  ],
  "Strawberry": [
    "Strawberry",
    "الفراولة",
    "🍓"
  ],
  "Styrax": [
    "Styrax",
    "الستيراكس",
    "🟤"
  ],
  "Tangerine": [
    "Tangerine",
    "اليوسفي الناضج",
    "🍊"
  ],
  "Teak Wood": [
    "Teak Wood",
    "خشب الساج",
    "🪵"
  ],
  "Thyme": [
    "Thyme",
    "الزعتر",
    "🌿"
  ],
  "Tobacco": [
    "Tobacco",
    "التبغ",
    "🍂"
  ],
  "Tobacco Leaf": [
    "Tobacco Leaf",
    "أوراق التبغ",
    "🍂"
  ],
  "Tonka Bean": [
    "Tonka Bean",
    "حبوب التونكا",
    "🌰"
  ],
  "Tropical Notes": [
    "Tropical Notes",
    "نفحات استوائية",
    "🌴"
  ],
  "Tuberose": [
    "Tuberose",
    "مسك الروم",
    "🌼"
  ],
  "Tunisian Neroli": [
    "Tunisian Neroli",
    "النيرولي التونسي",
    "🌼"
  ],
  "Turkish Rose": [
    "Turkish Rose",
    "الورد التركي",
    "🌹"
  ],
  "Vanilla": [
    "Vanilla",
    "الفانيليا",
    "🌼"
  ],
  "Vanilla Accord": [
    "Vanilla Accord",
    "نفحات الفانيليا",
    "🌼"
  ],
  "Vetiver": [
    "Vetiver",
    "نجيل الهند",
    "🌾"
  ],
  "Violet": [
    "Violet",
    "البنفسج",
    "🪻"
  ],
  "Violet Leaf": [
    "Violet Leaf",
    "أوراق البنفسج",
    "🍃"
  ],
  "Virginia Cedarwood": [
    "Virginia Cedarwood",
    "خشب أرز فرجينيا",
    "🪵"
  ],
  "Warm Spices": [
    "Warm Spices",
    "توابل دافئة",
    "🟤"
  ],
  "Watery Notes": [
    "Watery Notes",
    "نفحات مائية",
    "💧"
  ],
  "White Amber": [
    "White Amber",
    "العنبر الأبيض",
    "🤍"
  ],
  "White Flowers": [
    "White Flowers",
    "الزهور البيضاء",
    "🌼"
  ],
  "White Musk": [
    "White Musk",
    "المسك الأبيض",
    "🤍"
  ],
  "White Rum": [
    "White Rum",
    "الروم الأبيض",
    "🥃"
  ],
  "White Tobacco": [
    "White Tobacco",
    "التبغ الأبيض",
    "🍂"
  ],
  "Woody Notes": [
    "Woody Notes",
    "نفحات خشبية",
    "🪵"
  ],
  "Ylang-Ylang": [
    "Ylang-Ylang",
    "الإيلنغ إيلنغ",
    "🌼"
  ]
};
  var NOTE_LOOKUP = {};
  Object.keys(NOTE_LABELS).forEach(function (key) {
    var entry = NOTE_LABELS[key];
    NOTE_LOOKUP[fold(entry[0])] = entry;
    NOTE_LOOKUP[fold(entry[1])] = entry;
  });
  var NOTE_AR_ALIASES = {
    'فانيليا البوربون': 'Bourbon Vanilla', 'فانيليا بوربون': 'Bourbon Vanilla',
    'فانيلا': 'Vanilla', 'فانيليا': 'Vanilla', 'فانيلا البوربون': 'Bourbon Vanilla',
    'قرفة': 'Cinnamon', 'برغموت': 'Bergamot', 'هيل': 'Cardamom',
    'زهر البرتقال': 'Orange Blossom', 'خشب الغاياك': 'Guaiac Wood',
    'امبروكسان': 'Ambroxan',
    'مسك': 'Musk', 'برالين': 'Praline', 'إليمي': 'Elemi', 'اليمي': 'Elemi'
  };
  Object.keys(NOTE_AR_ALIASES).forEach(function (label) {
    NOTE_LOOKUP[fold(label)] = NOTE_LABELS[NOTE_AR_ALIASES[label]];
  });
  function canonicalNote(name) {
    var entry = NOTE_LOOKUP[fold(name)];
    return entry ? entry[0] : name;
  }
  function noteLabel(name, arabic) {
    var entry = NOTE_LOOKUP[fold(name)];
    return entry ? entry[arabic ? 1 : 0] : name;
  }
  function noteIcon(name) {
    var entry = NOTE_LOOKUP[fold(name)];
    return entry ? entry[2] : '🌿';
  }

  var NOTE_MODIFIERS = /\b(bourbon|madagascar|tahitian|mexican|white|pink|black|red|green|sicilian|calabrian|italian|egyptian|turkish|bulgarian|indian|haitian|javanese|virginian|virginia|atlas|australian|ceylon|french|damask|centifolia|wild|sweet|fresh|dark|golden|smoky|absolute|accord|essence|extract)\b/g;
  var NOTE_SYNONYMS = {
    'tonka bean': 'tonka', 'tonka beans': 'tonka', 'agarwood': 'oud', 'oud wood': 'oud', 'agarwood oud': 'oud',
    'vanilla bean': 'vanilla', 'vanille': 'vanilla', 'olibanum': 'incense', 'frankincense': 'incense',
    'ambergris': 'amber', 'patchouli leaf': 'patchouli', 'sea notes': 'marine', 'sea salt': 'salt',
    'woody notes': 'woods', 'musks': 'musk', 'cedarwood': 'cedar', 'sandal wood': 'sandalwood',
    'mandarin orange': 'mandarin', 'bitter orange': 'orange', 'blood orange': 'orange'
  };
  var NOTE_STOP = { wood: 1, woods: 1, notes: 1, note: 1, leaf: 1, leaves: 1, flower: 1, flowers: 1, blossom: 1, oil: 1, tree: 1 };

  /* Note families: used for chip colours and for the "accord" profile of a fragrance. */
  var NOTE_COLORS = [
    [/bergamot|lemon|orange|mandarin|grapefruit|lime|yuzu|citrus|citron|tangerine|petitgrain|neroli/, '#E9C46A'],
    [/rose|jasmin|tuberose|iris|violet|lily|peony|magnolia|ylang|gardenia|orchid|heliotrope|geranium|osmanthus|mimosa|freesia|lotus|floral|blossom/, '#E7A1B0'],
    [/vanill|praline|tonka|caramel|honey|chocolate|cacao|coffee|almond|sugar|benzoin|marshmallow|cotton candy|toffee|milk|cream|chestnut|hazelnut/, '#D9B48F'],
    [/cinnamon|cardamom|pepper|saffron|clove|nutmeg|ginger|cumin|anise|spice|elemi/, '#C8664A'],
    [/amber|ambrox|ambergris|labdanum|myrrh|incense|olibanum|styrax|resin|opoponax|copal/, '#C98B3F'],
    [/oud|agarwood/, '#7A4E36'],
    [/cedar|sandal|vetiver|guaiac|patchouli|birch|cypress|pine|wood|oakmoss|moss|cashmeran|papyrus/, '#9A7652'],
    [/leather|suede|tobacco|rum|whisk|cognac|smok|tar/, '#6E4630'],
    [/musk|powder|aldehyd|cotton|clean/, '#D8D0C4'],
    [/sea|marine|aquatic|water|salt|ozon|calone|rain/, '#5FA8C2'],
    [/mint|tea|basil|sage|rosemary|lavender|galbanum|green|grass|fig leaf|thyme|tarragon|artemisia|herb|violet leaf/, '#7DB38A'],
    [/apple|pineapple|peach|pear|berr|raspberry|plum|cherry|currant|cassis|fig|coconut|lychee|melon|mango|apricot|pomegranate|fruit|grape|strawberry|quince/, '#D46A78']
  ];

  function noteCategory(name) {
    var s = fold(canonicalNote(name));
    for (var i = 0; i < NOTE_COLORS.length; i++) {
      if (NOTE_COLORS[i][0].test(s)) return i;
    }
    return -1;
  }

  function noteColor(name) {
    var i = noteCategory(name);
    return i === -1 ? '' : NOTE_COLORS[i][1];
  }

  function noteEntry(name, tier) {
    var k = keyOf(canonicalNote(name));
    if (NOTE_SYNONYMS[k]) k = NOTE_SYNONYMS[k];
    var r = k.replace(NOTE_MODIFIERS, ' ').replace(/\s+/g, ' ').trim() || k;
    if (NOTE_SYNONYMS[r]) r = NOTE_SYNONYMS[r];
    var tokens = r.split(' ').filter(function (t) { return t.length > 2 && !NOTE_STOP[t]; });
    return { name: name, k: k, r: r, tokens: tokens, tier: tier, cat: noteCategory(name) };
  }

  /* Note images live in Content > Files as note-NAME.png. "Bourbon Vanilla" tries
     note-bourbon-vanilla.png first, then falls back to note-vanilla.png. */
  var NOTE_IMAGE_MISSING = {};

  function noteImageUrls(base, name) {
    var e = noteEntry(name, 0);
    var slugs = [slugOf(canonicalNote(name)), e.k, e.r].map(function (s) { return String(s).replace(/\s+/g, '-'); });
    var seen = {};
    return slugs.filter(function (s) {
      if (!s || seen[s]) return false;
      seen[s] = 1;
      return true;
    }).map(function (s) {
      return base + 'note-' + s + '.png?width=96';
    }).filter(function (u) {
      return !NOTE_IMAGE_MISSING[u];
    });
  }

  function noteImageError(img) {
    NOTE_IMAGE_MISSING[img.getAttribute('src')] = 1;
    var rest = (img.getAttribute('data-alt') || '').split('|').filter(function (u) { return u && !NOTE_IMAGE_MISSING[u]; });
    if (!rest.length) { img.remove(); return; }
    img.setAttribute('data-alt', rest.slice(1).join('|'));
    img.setAttribute('src', rest[0]);
  }

  function noteMatch(a, b) {
    if (a.k === b.k) return 1;
    if (a.r === b.r) return 0.85;
    for (var i = 0; i < a.tokens.length; i++) {
      if (b.tokens.indexOf(a.tokens[i]) !== -1) return 0.5;
    }
    return 0;
  }

  var TIER_WEIGHT = [1, 1.15, 1.3];
  var CAT_TIER_WEIGHT = [0.8, 1, 1.2];

  function directional(listA, listB) {
    var total = 0;
    var got = 0;
    listA.forEach(function (a) {
      var w = TIER_WEIGHT[a.tier] || 1;
      var best = 0;
      listB.forEach(function (b) {
        var m = noteMatch(a, b);
        if (m > 0 && a.tier !== b.tier) m *= 0.85;
        if (m > best) best = m;
      });
      total += w;
      got += w * best;
    });
    return total ? got / total : 0;
  }

  function accordVector(notes) {
    var vec = new Array(NOTE_COLORS.length).fill(0);
    notes.forEach(function (n) {
      if (n.cat >= 0) vec[n.cat] += CAT_TIER_WEIGHT[n.tier] || 1;
    });
    return vec;
  }

  function cosine(a, b) {
    var dot = 0, na = 0, nb = 0;
    for (var i = 0; i < a.length; i++) { dot += a[i] * b[i]; na += a[i] * a[i]; nb += b[i] * b[i]; }
    return na && nb ? dot / Math.sqrt(na * nb) : 0;
  }

  /* Returns 0..99, or null when there is not enough data to compare. */
  function similarity(a, b) {
    if (!a.notes.length || !b.notes.length) return null;
    var notes = (directional(a.notes, b.notes) + directional(b.notes, a.notes)) / 2;
    var accords = cosine(a.vec, b.vec);
    var family = a.familyKey && b.familyKey ? (a.familyKey === b.familyKey ? 1 : 0) : 0.5;
    var gender = !a.gender || !b.gender ? 0.6 : a.gender === b.gender ? 1 : (a.gender === 'unisex' || b.gender === 'unisex' ? 0.7 : 0.1);
    var season = !a.season || !b.season ? 0.7 : a.season === b.season || a.season === 'allyear' || b.season === 'allyear' ? 1 : 0.4;
    var raw = 0.38 * notes + 0.37 * accords + 0.15 * family + 0.06 * gender + 0.04 * season;
    /* Ease the raw score so close pairs read as close (0.5 -> ~71, 0.7 -> ~87). */
    var eased = 1 - Math.pow(1 - Math.max(0, Math.min(1, raw)), 1.8);
    return Math.max(0, Math.min(99, Math.round(eased * 100)));
  }

  var FAMILY_COLORS = [
    [/citrus|fresh/, ['#D9B44A', '#3D3415']],
    [/aquatic|marine|ocean/, ['#4C93B0', '#11252F']],
    [/floral|tea/, ['#C9879A', '#36202A']],
    [/fruit/, ['#C45A6A', '#331A1F']],
    [/gourmand|sweet|vanilla/, ['#C89A6A', '#35261A']],
    [/amber|spic|oriental/, ['#C27838', '#3A2210']],
    [/oud/, ['#8A5A3C', '#24160F']],
    [/green|aromatic|fougere|herb/, ['#6FA07A', '#18281C']],
    [/leather|tobacco/, ['#7A5236', '#20150E']],
    [/wood/, ['#9C7350', '#2A1E14']],
    [/musk|powder/, ['#BDB3A6', '#2C2925']]
  ];

  function familyColors(name, fallback) {
    var s = fold(name);
    for (var i = 0; i < FAMILY_COLORS.length; i++) {
      if (FAMILY_COLORS[i][0].test(s)) return FAMILY_COLORS[i][1];
    }
    return [fallback || '#8C6D4F', '#211912'];
  }

  /* --------------------------------------------------------------- icons */

  var ICON_CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_X_SMALL = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  /* ========================================================= ProductView */

  /* One rendered product (the bottom sheet, or the inline hero panel) with its own size, quantity and cart button. */
  function ProductView(boutique, el, inline) {
    var self = this;
    this.b = boutique;
    this.el = el;
    this.inline = inline;
    this.product = null;
    this.variant = null;
    this.qty = 1;
    el.addEventListener('click', function (e) { self.onClick(e); });
  }

  ProductView.prototype.render = function (p) {
    this.product = p;
    this.variant = this.b.pickVariant(p);
    this.qty = 1;
    this.el.innerHTML = this.b.productHTML(p, this);
    this.updateBar();
    this.b.loadDetails(p);
  };

  /* Called when live product data (availability, description) arrives. */
  ProductView.prototype.refresh = function () {
    var p = this.product;
    if (!p) return;
    $$('[data-fb-variant]', this.el).forEach(function (btn) {
      var v = p.variants.filter(function (x) { return String(x.id) === btn.getAttribute('data-fb-variant'); })[0];
      if (v) btn.classList.toggle('is-out', !v.available);
    });
    if (this.variant && !this.variant.available) {
      var better = this.b.pickVariant(p);
      if (better && better.available) this.selectVariant(better.id);
    }
    this.updateBar();
    var about = $('[data-fb-about]', this.el);
    var desc = p.details && p.details.description;
    if (about && about.hidden && desc && desc.replace(/<[^>]*>/g, '').trim()) {
      about.innerHTML = '<details><summary>' + esc(this.b.l.about) + '</summary><div class="fb-rte">' + desc + '</div></details>';
      about.hidden = false;
    }
  };

  ProductView.prototype.selectVariant = function (id) {
    var p = this.product;
    if (!p) return;
    var v = p.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v) return;
    this.variant = v;
    $$('[data-fb-variant]', this.el).forEach(function (btn) {
      var on = btn.getAttribute('data-fb-variant') === String(id);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', on);
    });
    this.updateBar();
  };

  ProductView.prototype.updateBar = function () {
    var btn = $('[data-fb-add]', this.el);
    var qtyEl = $('[data-fb-qty-val]', this.el);
    if (!btn) return;
    var v = this.variant;
    var l = this.b.l;
    if (qtyEl) qtyEl.textContent = this.qty;
    btn.classList.remove('is-ask');
    if (!v) {
      btn.disabled = true;
      btn.textContent = l.soldout;
      return;
    }
    if (!v.available) {
      if (this.b.cfg.whatsapp) {
        btn.disabled = false;
        btn.classList.add('is-ask');
        btn.textContent = l.ask;
      } else {
        btn.disabled = true;
        btn.textContent = l.soldout;
      }
      return;
    }
    btn.disabled = false;
    btn.textContent = l.add + DOT + this.b.money(v.price * this.qty);
  };

  ProductView.prototype.onClick = function (e) {
    var t = e.target;
    if (t.closest('[data-fb-close]')) { this.b.close(); return; }
    var open = t.closest('[data-fb-open]');
    if (open) { e.preventDefault(); this.b.open(open.getAttribute('data-fb-open')); return; }
    var variant = t.closest('[data-fb-variant]');
    if (variant) { this.selectVariant(variant.getAttribute('data-fb-variant')); return; }
    var qty = t.closest('[data-fb-qty]');
    if (qty) {
      this.qty = Math.max(1, Math.min(20, this.qty + parseInt(qty.getAttribute('data-fb-qty'), 10)));
      this.updateBar();
      return;
    }
    var add = t.closest('[data-fb-add]');
    if (add) {
      if (add.classList.contains('is-ask')) this.askWhatsapp();
      else this.addToCart(add);
    }
  };

  ProductView.prototype.askWhatsapp = function () {
    var p = this.product;
    var v = this.variant;
    var text = (this.b.l.askText || '[product]')
      .replace('[product]', p ? p.title : '')
      .replace('[size]', v ? v.title : '')
      + '\n' + window.location.origin + (p ? p.url : '');
    window.open('https://wa.me/' + this.b.cfg.whatsapp + '?text=' + encodeURIComponent(text), '_blank', 'noopener');
  };

  ProductView.prototype.addToCart = function (btn) {
    var self = this;
    var b = this.b;
    var p = this.product;
    var v = this.variant;
    var qty = this.qty;
    if (!p || !v || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');

    var sectionIds = $$('cart-items-component').map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
    var body = { items: [{ id: v.id, quantity: qty }] };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    var events = null;
    var deferred = null;
    var source = this.el;

    /* Horizon listens for the standard cart event to refresh the cart icon and drawer. */
    var start = import('@shopify/events')
      .then(function (mod) {
        if (!mod || !mod.CartLinesUpdateEvent) return;
        events = mod;
        deferred = mod.CartLinesUpdateEvent.createPromise();
        source.dispatchEvent(new mod.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(v.id), quantity: qty }],
          promise: deferred.promise
        }));
      })
      .catch(function () { /* theme without standard events */ });

    var addUrl = (b.cfg.cartAdd || '/cart/add') + '.js';
    var cartUrl = (b.cfg.cart || '/cart') + '.js';

    start
      .then(function () {
        return fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          throw new Error(res.json.description || res.json.message || b.l.error);
        }
        return fetch(cartUrl, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (events && deferred) {
              deferred.resolve({
                cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse
                  ? events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart)
                  : cart,
                detail: {
                  items: cart.items,
                  source: 'fragrance-boutique',
                  sourceId: 'fb-' + b.sectionId,
                  itemCount: qty,
                  productId: String(p.id),
                  sections: res.json.sections,
                  didError: false
                }
              });
            } else {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: cart, sourceId: 'fb-' + b.sectionId, data: { source: 'fragrance-boutique', itemCount: qty, sections: res.json.sections } }
              }));
            }
            b.updateCartCount(cart.item_count);
          });
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        btn.textContent = b.l.added;
        b.toast();
        setTimeout(function () {
          btn.classList.remove('is-done');
          self.updateBar();
          if (!self.inline && b.cfg.closeAfterAdd) b.close();
        }, 900);
      })
      .catch(function (err) {
        if (deferred) {
          try {
            deferred.resolve({ cart: null, detail: { didError: true, source: 'fragrance-boutique', sourceId: 'fb-' + b.sectionId } });
          } catch (e) { /* ignore */ }
        }
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = (err && err.message) || b.l.error;
        setTimeout(function () { self.updateBar(); }, 2500);
      });
  };

  /* ============================================================ Boutique */

  function Boutique(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    var cfgEl = $('script[data-fb-config]', root);
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { l: {} };
    this.l = this.cfg.l || {};
    this.byHandle = new Map();
    this.order = [];
    this.best = [];
    this.hero = null;
    this.pages = 1;
    this.state = { q: '', g: new Set(), s: new Set(), f: '', stock: false, sort: 'featured', shown: this.cfg.pageSize || 24 };
    this.finder = { love: [], notes: [] };
    this.simCache = new Map();
    this.openedHere = false;
    this.views = [];
    this.init();
  }

  Boutique.prototype.init = function () {
    var self = this;
    var dataEl = $('script[data-fb-data]', this.root);
    if (dataEl) {
      try {
        this.ingest(JSON.parse(dataEl.textContent));
      } catch (err) {
        console.error('[fragrance-boutique] data error', err);
      }
    }
    this.bind();
    this.renderAll();
    this.loadRemainingPages();
    this.onHash();
    this.hashHandler = function () { self.onHash(); };
    window.addEventListener('hashchange', this.hashHandler);
  };

  Boutique.prototype.destroy = function () {
    window.removeEventListener('hashchange', this.hashHandler);
  };

  /* --------------------------------------------------------------- data */

  Boutique.prototype.ingest = function (data) {
    var self = this;
    if (!data) return;
    if (data.pages) this.pages = data.pages;
    if (data.hero) this.hero = data.hero;
    if (Array.isArray(data.best) && data.best.length) this.best = data.best;
    (data.products || []).forEach(function (raw) {
      var existing = self.byHandle.get(raw.h);
      if (existing) {
        if (raw.m && !existing.inMain) {
          existing.inMain = true;
          self.order.push(raw.h);
        }
        return;
      }
      var p = self.normalize(raw);
      self.byHandle.set(p.handle, p);
      if (p.inMain) self.order.push(p.handle);
    });
    this.simCache.clear();
  };

  Boutique.prototype.normalize = function (raw) {
    var arabic = this.root.getAttribute('dir') === 'rtl';
    function localizedList(value) {
      return splitList(value).map(function (name) { return noteLabel(name, arabic); });
    }
    var top = localizedList(raw.tn);
    var heart = localizedList(raw.hn);
    var base = localizedList(raw.bn);
    var notes = [];
    top.forEach(function (n) { notes.push(noteEntry(n, 0)); });
    heart.forEach(function (n) { notes.push(noteEntry(n, 1)); });
    base.forEach(function (n) { notes.push(noteEntry(n, 2)); });
    var variants = (raw.v || []).map(function (v) {
      return { id: v.id, title: v.n, price: v.p, compare: v.c || 0, available: !!v.a };
    });
    var prices = variants.map(function (v) { return v.price; });
    var minPrice = prices.length ? Math.min.apply(null, prices) : 0;
    var maxPrice = prices.length ? Math.max.apply(null, prices) : 0;
    var discount = 0;
    variants.forEach(function (v) {
      if (v.compare > v.price) {
        var d = Math.round((1 - v.price / v.compare) * 100);
        if (d > discount) discount = d;
      }
    });
    return {
      id: raw.id,
      handle: raw.h,
      title: raw.t,
      url: raw.u,
      image: raw.i,
      imageAlt: raw.t,
      inspired: raw.ib || '',
      concentration: raw.c || '',
      family: raw.f || '',
      familyKey: keyOf(raw.f),
      gender: genderKey(raw.g),
      season: seasonKey(raw.s),
      top: top,
      heart: heart,
      base: base,
      notes: notes,
      vec: accordVector(notes),
      longevity: Math.max(0, Math.min(5, parseInt(raw.lo, 10) || 0)),
      sillage: Math.max(0, Math.min(5, parseInt(raw.si, 10) || 0)),
      manualSimilar: raw.sim || [],
      available: !!raw.a,
      inMain: !!raw.m,
      variants: variants,
      minPrice: minPrice,
      priceVaries: minPrice !== maxPrice,
      discount: discount,
      search: fold([raw.t, raw.ib, raw.f, raw.c, top.join(' '), heart.join(' '), base.join(' ')].join(' '))
    };
  };

  Boutique.prototype.loadRemainingPages = function () {
    var self = this;
    if (this.pages <= 1) return;
    var page = 2;
    var next = function () {
      if (page > self.pages) return;
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(self.sectionId) + '&page=' + page;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('script[data-fb-data]');
          if (el) self.ingest(JSON.parse(el.textContent));
          self.renderFamilies();
          self.renderGrid();
          self.renderFinderResults();
          page += 1;
          next();
        })
        .catch(function (err) { console.warn('[fragrance-boutique] page load failed', err); });
    };
    next();
  };

  Boutique.prototype.mainProducts = function () {
    var self = this;
    return this.order.map(function (h) { return self.byHandle.get(h); }).filter(Boolean);
  };

  Boutique.prototype.allProducts = function () {
    return Array.from(this.byHandle.values());
  };

  Boutique.prototype.isBest = function (p) {
    return this.best.indexOf(p.handle) !== -1;
  };

  Boutique.prototype.money = function (cents) {
    return formatMoney(cents, this.cfg.moneyFormat);
  };

  Boutique.prototype.genderLabel = function (k) {
    return k ? this.l[k] || k : '';
  };

  Boutique.prototype.seasonLabel = function (k) {
    return k ? this.l[k] || k : '';
  };

  Boutique.prototype.closest = function (p, limit) {
    var self = this;
    if (this.simCache.has(p.handle)) return this.simCache.get(p.handle).slice(0, limit);
    var result = [];
    if (p.manualSimilar && p.manualSimilar.length) {
      p.manualSimilar.forEach(function (h) {
        var other = self.byHandle.get(h);
        if (other && other.handle !== p.handle) result.push({ p: other, score: similarity(p, other) });
      });
    } else if (p.notes.length) {
      var min = this.cfg.simMin || 55;
      this.allProducts().forEach(function (other) {
        if (other.handle === p.handle) return;
        var s = similarity(p, other);
        if (s !== null && s >= min) result.push({ p: other, score: s });
      });
      result.sort(function (a, b) { return b.score - a.score || Number(b.p.available) - Number(a.p.available); });
      result = result.slice(0, 12);
    }
    this.simCache.set(p.handle, result);
    return result.slice(0, limit);
  };

  /* ------------------------------------------------------------- binding */

  Boutique.prototype.bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('click', function (e) {
      var t = e.target;
      /* Product views handle their own clicks. */
      if (t.closest('[data-fb-panel], [data-fb-feature-panel]')) return;
      var open = t.closest('[data-fb-open]');
      if (open) {
        e.preventDefault();
        self.open(open.getAttribute('data-fb-open'));
        return;
      }
      var scrollLink = t.closest('[data-fb-scroll]');
      if (scrollLink) {
        var target = document.querySelector(scrollLink.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      var rail = t.closest('[data-fb-rail]');
      if (rail) {
        var list = $('[data-fb-best]', root);
        if (list) {
          var dir = parseInt(rail.getAttribute('data-fb-rail'), 10);
          if (getComputedStyle(root).direction === 'rtl') dir *= -1;
          list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: 'smooth' });
        }
        return;
      }
      var fam = t.closest('[data-fb-family]');
      if (fam) {
        self.state.f = fam.getAttribute('data-fb-family');
        self.state.shown = self.cfg.pageSize || 24;
        self.renderGrid();
        var grid = document.getElementById('fb-' + self.sectionId + '-collection');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var chip = t.closest('[data-fb-chip]');
      if (chip) {
        self.toggleChip(chip.getAttribute('data-fb-chip'), chip.getAttribute('data-fb-value'));
        return;
      }
      if (t.closest('[data-fb-more]')) {
        self.state.shown += self.cfg.pageSize || 24;
        self.renderGrid();
      }
    });

    var q = $('[data-fb-q]', root);
    if (q) {
      q.addEventListener('input', debounce(function () {
        self.state.q = fold(q.value);
        self.state.shown = self.cfg.pageSize || 24;
        self.renderGrid();
      }, 150));
    }

    var sort = $('[data-fb-sort]', root);
    if (sort) {
      sort.addEventListener('change', function () {
        self.state.sort = sort.value;
        self.renderGrid();
      });
    }

    $$('[data-fb-picker]', root).forEach(function (picker) { self.bindPicker(picker); });

    /* Bottom sheet */
    this.dialog = $('[data-fb-sheet]', root);
    this.panel = $('[data-fb-panel]', root);
    if (this.dialog && this.panel) {
      this.sheetView = new ProductView(this, this.panel, false);
      this.views.push(this.sheetView);
      this.dialog.addEventListener('click', function (e) {
        if (e.target === self.dialog) self.close();
      });
      this.dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        self.close();
      });
      this.bindDrag();
    }

    /* Inline hero product */
    var feature = $('[data-fb-feature-panel]', root);
    if (feature) {
      this.featureView = new ProductView(this, feature, true);
      this.views.push(this.featureView);
    }
  };

  Boutique.prototype.toggleChip = function (type, value) {
    var st = this.state;
    if (type === 'clear') {
      st.g.clear();
      st.s.clear();
      st.f = '';
      st.stock = false;
      st.q = '';
      var q = $('[data-fb-q]', this.root);
      if (q) q.value = '';
    } else if (type === 'g' || type === 's') {
      if (st[type].has(value)) st[type].delete(value);
      else st[type].add(value);
    } else if (type === 'stock') {
      st.stock = !st.stock;
    } else if (type === 'f') {
      st.f = st.f === value ? '' : value;
    }
    st.shown = this.cfg.pageSize || 24;
    this.renderGrid();
  };

  /* ------------------------------------------------------------ rendering */

  Boutique.prototype.renderAll = function () {
    this.renderFeature();
    this.renderBest();
    this.renderFamilies();
    this.renderGrid();
  };

  Boutique.prototype.renderFeature = function () {
    if (!this.featureView || !this.hero) return;
    var p = this.byHandle.get(this.hero);
    if (p) this.featureView.render(p);
  };

  Boutique.prototype.cardHTML = function (p, opts) {
    var l = this.l;
    opts = opts || {};
    var meta = [p.family, this.genderLabel(p.gender), this.seasonLabel(p.season)].filter(Boolean).join(DOT);
    var badges = '';
    if (!p.available) badges += '<span class="fb-badge fb-badge--muted">' + esc(l.soldout) + '</span>';
    else if (p.discount) badges += '<span class="fb-badge fb-badge--accent">-' + p.discount + '%</span>';
    if (this.isBest(p) && !opts.hideBest) badges += '<span class="fb-badge">' + esc(l.best) + '</span>';
    var img = p.image
      ? '<img src="' + esc(p.image) + '" alt="' + esc(p.imageAlt) + '" loading="lazy" decoding="async" width="600" height="600">'
      : '<span class="fb-card__ph" aria-hidden="true">' + esc((p.title || '?').charAt(0)) + '</span>';
    var score = opts.score != null ? '<span class="fb-card__score">' + opts.score + '% ' + esc(l.match) + '</span>' : '';
    return (
      '<article class="fb-card' + (p.available ? '' : ' is-soldout') + '">' +
        '<a class="fb-card__media" href="#p/' + esc(p.handle) + '" data-fb-open="' + esc(p.handle) + '" aria-label="' + esc(p.title) + '">' +
          img +
          '<span class="fb-card__badges">' + badges + '</span>' +
          (p.concentration ? '<span class="fb-card__conc">' + esc(p.concentration) + '</span>' : '') +
          score +
        '</a>' +
        '<div class="fb-card__body">' +
          (p.inspired ? '<p class="fb-card__house">' + esc(p.inspired) + '</p>' : '') +
          '<h3 class="fb-card__title"><a href="#p/' + esc(p.handle) + '" data-fb-open="' + esc(p.handle) + '">' + esc(p.title) + '</a></h3>' +
          (meta ? '<p class="fb-card__meta">' + esc(meta) + '</p>' : '') +
          '<div class="fb-card__foot">' +
            '<p class="fb-card__price">' + (p.priceVaries ? '<span>' + esc(l.from) + '</span> ' : '') + esc(this.money(p.minPrice)) + '</p>' +
            '<button type="button" class="fb-card__quick" data-fb-open="' + esc(p.handle) + '">' + esc(l.quick) + '</button>' +
          '</div>' +
        '</div>' +
      '</article>'
    );
  };

  Boutique.prototype.renderBest = function () {
    var self = this;
    var list = $('[data-fb-best]', this.root);
    if (!list) return;
    var items = this.best.map(function (h) { return self.byHandle.get(h); }).filter(Boolean);
    var block = $('[data-fb-best-block]', this.root);
    if (block) block.hidden = !items.length;
    list.innerHTML = items.map(function (p) { return self.cardHTML(p, { hideBest: true }); }).join('');
  };

  Boutique.prototype.familyList = function () {
    var counts = new Map();
    this.mainProducts().forEach(function (p) {
      if (!p.familyKey) return;
      var item = counts.get(p.familyKey);
      if (!item) {
        item = { key: p.familyKey, name: p.family, count: 0 };
        counts.set(p.familyKey, item);
      }
      item.count += 1;
    });
    /* Family blocks (theme editor) add an image / colour and come first, in their own order. */
    var blocks = (this.cfg.families || []).filter(function (b) { return b && b.name; });
    var ordered = [];
    blocks.forEach(function (b) {
      var item = counts.get(keyOf(b.name));
      if (!item || item.styled) return;
      item.img = b.img;
      item.color = b.color;
      item.styled = true;
      ordered.push(item);
    });
    var rest = Array.from(counts.values())
      .filter(function (f) { return !f.styled; })
      .sort(function (a, b) { return b.count - a.count; });
    return ordered.concat(rest);
  };

  Boutique.prototype.renderFamilies = function () {
    var wrap = $('[data-fb-families]', this.root);
    if (!wrap) return;
    var l = this.l;
    var fams = this.familyList();
    var block = $('[data-fb-families-block]', this.root);
    if (block) block.hidden = fams.length < 2;
    wrap.innerHTML = fams.map(function (f) {
      var colors = familyColors(f.name, f.color);
      var bg = f.img ? '<img src="' + esc(f.img) + '" alt="" loading="lazy" decoding="async">' : '';
      return (
        '<button type="button" class="fb-family" data-fb-family="' + esc(f.key) + '" style="--fb-fam:' + esc(f.color || colors[0]) + ';--fb-fam-2:' + esc(colors[1]) + '">' +
          bg +
          '<span class="fb-family__name">' + esc(f.name) + '</span>' +
          '<span class="fb-family__count">' + f.count + ' ' + esc(l.fragrances) + '</span>' +
        '</button>'
      );
    }).join('');
  };

  Boutique.prototype.filtered = function (ignore) {
    var st = this.state;
    return this.mainProducts().filter(function (p) {
      if (st.q && p.search.indexOf(st.q) === -1) return false;
      if (ignore !== 'g' && st.g.size && !st.g.has(p.gender)) return false;
      if (ignore !== 's' && st.s.size && !(st.s.has(p.season) || p.season === 'allyear')) return false;
      if (ignore !== 'f' && st.f && p.familyKey !== st.f) return false;
      if (ignore !== 'stock' && st.stock && !p.available) return false;
      return true;
    });
  };

  Boutique.prototype.renderChips = function () {
    var wrap = $('[data-fb-chips]', this.root);
    if (!wrap) return;
    var st = this.state;
    var l = this.l;
    var all = this.mainProducts();
    var html = '';
    var count = function (list, fn) { return list.filter(fn).length; };

    var gBase = this.filtered('g');
    [['him', l.him], ['her', l.her], ['unisex', l.unisex]].forEach(function (g) {
      if (!all.some(function (p) { return p.gender === g[0]; })) return;
      var n = count(gBase, function (p) { return p.gender === g[0]; });
      html += '<button type="button" class="fb-chip' + (st.g.has(g[0]) ? ' is-on' : '') + '" data-fb-chip="g" data-fb-value="' + g[0] + '" aria-pressed="' + st.g.has(g[0]) + '">' + esc(g[1]) + ' <span>' + n + '</span></button>';
    });

    var sBase = this.filtered('s');
    var seasonHtml = '';
    [['summer', l.summer], ['winter', l.winter], ['allyear', l.allyear]].forEach(function (s) {
      if (!all.some(function (p) { return p.season === s[0]; })) return;
      var n = count(sBase, function (p) { return p.season === s[0] || (s[0] !== 'allyear' && p.season === 'allyear'); });
      seasonHtml += '<button type="button" class="fb-chip' + (st.s.has(s[0]) ? ' is-on' : '') + '" data-fb-chip="s" data-fb-value="' + s[0] + '" aria-pressed="' + st.s.has(s[0]) + '">' + esc(s[1]) + ' <span>' + n + '</span></button>';
    });
    if (html && seasonHtml) html += '<span class="fb-chips__sep" aria-hidden="true"></span>';
    html += seasonHtml;

    if (all.some(function (p) { return !p.available; })) {
      var stockN = count(this.filtered('stock'), function (p) { return p.available; });
      if (html) html += '<span class="fb-chips__sep" aria-hidden="true"></span>';
      html += '<button type="button" class="fb-chip' + (st.stock ? ' is-on' : '') + '" data-fb-chip="stock" aria-pressed="' + st.stock + '">' + esc(l.instock) + ' <span>' + stockN + '</span></button>';
    }

    if (st.f) {
      var fam = this.familyList().filter(function (f) { return f.key === st.f; })[0];
      html += '<button type="button" class="fb-chip is-on" data-fb-chip="f" data-fb-value="' + esc(st.f) + '">' + esc(fam ? fam.name : st.f) + ' ' + ICON_X_SMALL + '</button>';
    } else {
      var fams = this.familyList();
      if (fams.length > 1) {
        var fBase = this.filtered('f');
        if (html) html += '<span class="fb-chips__sep" aria-hidden="true"></span>';
        fams.forEach(function (f) {
          var n = count(fBase, function (p) { return p.familyKey === f.key; });
          if (!n) return;
          html += '<button type="button" class="fb-chip" data-fb-chip="f" data-fb-value="' + esc(f.key) + '">' + esc(f.name) + ' <span>' + n + '</span></button>';
        });
      }
    }

    if (st.g.size || st.s.size || st.f || st.stock || st.q) {
      html += '<button type="button" class="fb-chip fb-chip--clear" data-fb-chip="clear">' + esc(l.clear) + '</button>';
    }
    wrap.innerHTML = html;
  };

  Boutique.prototype.renderGrid = function () {
    var grid = $('[data-fb-grid]', this.root);
    if (!grid) return;
    var self = this;
    var st = this.state;
    var list = this.filtered();
    if (st.sort === 'price-asc') list.sort(function (a, b) { return a.minPrice - b.minPrice; });
    else if (st.sort === 'price-desc') list.sort(function (a, b) { return b.minPrice - a.minPrice; });
    else if (st.sort === 'name') list.sort(function (a, b) { return a.title.localeCompare(b.title); });
    var shown = list.slice(0, st.shown);
    grid.innerHTML = shown.map(function (p) { return self.cardHTML(p); }).join('');
    var more = $('[data-fb-more]', this.root);
    if (more) more.hidden = list.length <= st.shown;
    var none = $('[data-fb-noresults]', this.root);
    if (none) none.hidden = list.length > 0;
    var countEl = $('[data-fb-count]', this.root);
    if (countEl) {
      countEl.textContent = (this.l.count || '[shown] / [total]')
        .replace('[shown]', shown.length)
        .replace('[total]', list.length) + ' ' + (this.l.fragrances || '');
    }
    this.renderChips();
  };

  /* -------------------------------------------------------------- finder */

  Boutique.prototype.bindPicker = function (picker) {
    var self = this;
    var type = picker.getAttribute('data-fb-picker');
    var input = $('[data-fb-input]', picker);
    var box = $('[data-fb-suggest]', picker);
    var tags = $('[data-fb-tags]', picker);
    var active = -1;
    var current = [];

    var options = function (q) {
      q = fold(q);
      if (type === 'love') {
        var chosen = self.finder.love;
        return self.allProducts()
          .filter(function (p) { return chosen.indexOf(p.handle) === -1 && (!q || p.search.indexOf(q) !== -1); })
          .sort(function (a, b) {
            var ai = fold(a.title).indexOf(q) === 0 || fold(a.inspired).indexOf(q) === 0 ? 0 : 1;
            var bi = fold(b.title).indexOf(q) === 0 || fold(b.inspired).indexOf(q) === 0 ? 0 : 1;
            return ai - bi || (b.notes.length ? 1 : 0) - (a.notes.length ? 1 : 0);
          })
          .slice(0, 8)
          .map(function (p) { return { value: p.handle, label: p.title, hint: p.inspired }; });
      }
      var picked = self.finder.notes.map(function (name) { return noteEntry(name, 1).k; });
      return self.noteIndex()
        .filter(function (n) { return picked.indexOf(n.k) === -1 && (!q || fold(n.name).indexOf(q) !== -1); })
        .sort(function (a, b) {
          var ai = fold(a.name).indexOf(q) === 0 ? 0 : 1;
          var bi = fold(b.name).indexOf(q) === 0 ? 0 : 1;
          return ai - bi || b.count - a.count;
        })
        .slice(0, 8)
        .map(function (n) { return { value: n.name, label: n.name, hint: n.count + ' ' + (self.l.fragrances || '') }; });
    };

    var draw = function () {
      current = options(input.value);
      active = -1;
      if (!current.length || document.activeElement !== input) {
        box.hidden = true;
        return;
      }
      box.innerHTML = current.map(function (o, i) {
        return '<li role="option" data-i="' + i + '"><span>' + esc(o.label) + '</span>' + (o.hint ? '<small>' + esc(o.hint) + '</small>' : '') + '</li>';
      }).join('');
      box.hidden = false;
    };

    var highlight = function () {
      $$('li', box).forEach(function (li, i) { li.classList.toggle('is-active', i === active); });
    };

    var drawTags = function () {
      var list = type === 'love' ? self.finder.love : self.finder.notes;
      tags.innerHTML = list.map(function (v, i) {
        var label = v;
        if (type === 'love') {
          var p = self.byHandle.get(v);
          label = p ? p.title : v;
        }
        return '<button type="button" class="fb-tag" data-i="' + i + '">' + esc(label) + ICON_X_SMALL + '</button>';
      }).join('');
    };

    var choose = function (o) {
      if (!o) return;
      if (type === 'love') self.finder.love.push(o.value);
      else self.finder.notes.push(o.value);
      input.value = '';
      drawTags();
      draw();
      self.renderFinderResults();
    };

    input.addEventListener('input', draw);
    input.addEventListener('focus', draw);
    input.addEventListener('blur', function () { setTimeout(function () { box.hidden = true; }, 150); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { active = Math.min(current.length - 1, active + 1); highlight(); e.preventDefault(); }
      else if (e.key === 'ArrowUp') { active = Math.max(0, active - 1); highlight(); e.preventDefault(); }
      else if (e.key === 'Enter') { e.preventDefault(); choose(current[active >= 0 ? active : 0]); }
      else if (e.key === 'Backspace' && !input.value) {
        var list = type === 'love' ? self.finder.love : self.finder.notes;
        if (list.length) { list.pop(); drawTags(); self.renderFinderResults(); }
      }
    });
    box.addEventListener('mousedown', function (e) {
      var li = e.target.closest('li');
      if (!li) return;
      e.preventDefault();
      choose(current[parseInt(li.getAttribute('data-i'), 10)]);
    });
    tags.addEventListener('click', function (e) {
      var btn = e.target.closest('.fb-tag');
      if (!btn) return;
      var list = type === 'love' ? self.finder.love : self.finder.notes;
      list.splice(parseInt(btn.getAttribute('data-i'), 10), 1);
      drawTags();
      self.renderFinderResults();
    });
  };

  Boutique.prototype.noteIndex = function () {
    if (this._noteIndex && this._noteIndexSize === this.byHandle.size) return this._noteIndex;
    var map = new Map();
    this.allProducts().forEach(function (p) {
      p.notes.forEach(function (n) {
        var item = map.get(n.k);
        if (!item) { item = { k: n.k, name: n.name, count: 0 }; map.set(n.k, item); }
        item.count += 1;
      });
    });
    this._noteIndex = Array.from(map.values());
    this._noteIndexSize = this.byHandle.size;
    return this._noteIndex;
  };

  Boutique.prototype.renderFinderResults = function () {
    var out = $('[data-fb-finder-results]', this.root);
    if (!out) return;
    var self = this;
    var loves = this.finder.love.map(function (h) { return self.byHandle.get(h); }).filter(Boolean);
    var picked = this.finder.notes.map(function (n) { return noteEntry(n, 1); });
    if (!loves.length && !picked.length) {
      out.innerHTML = '<p class="fb-muted">' + esc(this.l.finderEmpty) + '</p>';
      return;
    }
    var scored = [];
    this.allProducts().forEach(function (p) {
      if (self.finder.love.indexOf(p.handle) !== -1 || !p.notes.length) return;
      var parts = [];
      if (loves.length) {
        var best = 0;
        loves.forEach(function (lp) {
          var s = similarity(lp, p);
          if (s !== null && s > best) best = s;
        });
        parts.push(best);
      }
      if (picked.length) {
        var got = 0;
        picked.forEach(function (n) {
          var m = 0;
          p.notes.forEach(function (pn) {
            var x = noteMatch(n, pn);
            if (x > m) m = x;
          });
          got += m;
        });
        parts.push(Math.round((got / picked.length) * 99));
      }
      var score = Math.round(parts.reduce(function (a, b) { return a + b; }, 0) / parts.length);
      if (score > 0) scored.push({ p: p, score: score });
    });
    scored.sort(function (a, b) { return b.score - a.score || Number(b.p.available) - Number(a.p.available); });
    scored = scored.slice(0, 8);
    if (!scored.length) {
      out.innerHTML = '<p class="fb-muted">' + esc(this.l.finderEmpty) + '</p>';
      return;
    }
    out.innerHTML = '<div class="fb-grid fb-grid--finder">' + scored.map(function (r) {
      return self.cardHTML(r.p, { score: r.score });
    }).join('') + '</div>';
  };

  /* ------------------------------------------------------ product markup */

  Boutique.prototype.pickVariant = function (p) {
    var avail = p.variants.filter(function (v) { return v.available; });
    var list = avail.length ? avail : p.variants;
    if (!list.length) return null;
    return this.cfg.defaultSize === 'first' ? list[0] : list[list.length - 1];
  };

  Boutique.prototype.meterHTML = function (label, value) {
    if (!value) return '';
    var bars = '';
    for (var i = 1; i <= 5; i++) bars += '<i class="' + (i <= value ? 'is-on' : '') + '"></i>';
    return '<div class="fb-meter"><span class="fb-meter__label">' + esc(label) + '</span><span class="fb-meter__bars" role="img" aria-label="' + esc(label) + ' ' + value + '/5">' + bars + '</span></div>';
  };

  Boutique.prototype.noteChip = function (name) {
    var color = noteColor(name);
    var style = color ? ' style="--fb-note:' + color + '"' : '';
    var img = '';
    if (this.cfg.noteImages && this.cfg.filesBase) {
      var urls = noteImageUrls(this.cfg.filesBase, name);
      if (urls.length) {
        img = '<img src="' + esc(urls[0]) + '" data-alt="' + esc(urls.slice(1).join('|')) + '" alt="" loading="lazy" decoding="async" onerror="FragranceBoutique.noteImageError(this)">';
      }
    }
    return '<span class="fb-note"' + style + '><span class="fb-note__dot" aria-hidden="true">' + '<span style="font-size:20px;line-height:1">' + esc(noteIcon(name)) + '</span>' + img + '</span>' + esc(name) + '</span>';
  };

  /* Full product markup, shared by the bottom sheet and the inline hero panel. */
  Boutique.prototype.productHTML = function (p, view) {
    var self = this;
    var l = this.l;
    var inline = view.inline;
    var pills = [p.concentration, p.family, this.genderLabel(p.gender), this.seasonLabel(p.season)].filter(Boolean)
      .map(function (x) { return '<span class="fb-pill">' + esc(x) + '</span>'; }).join('');
    var meters = this.meterHTML(l.longevity, p.longevity) + this.meterHTML(l.sillage, p.sillage);

    var tiers = [[l.top, p.top], [l.heart, p.heart], [l.base, p.base]].filter(function (t) { return t[1].length; });
    var flatNotes = tiers.length === 1;
    var notesHeading = flatNotes
      ? (this.root.getAttribute('dir') === 'rtl' ? 'النوتات العطرية' : 'FRAGRANCE NOTES')
      : l.pyramid;
    var pyramid = tiers.length
      ? '<h3 class="fb-label">' + esc(notesHeading) + '</h3><div class="fb-pyr">' + tiers.map(function (t) {
          var chips = '<div class="fb-pyr__notes">' + t[1].map(function (n) { return self.noteChip(n); }).join('') + '</div>';
          return flatNotes ? chips : '<div class="fb-pyr__row"><div class="fb-pyr__tier">' + esc(t[0]) + '</div>' + chips + '</div>';
        }).join('') + '</div>'
      : '';

    var similar = '';
    if (this.cfg.showSimilar) {
      var close = this.closest(p, this.cfg.simCount || 3);
      if (close.length) {
        similar = '<h3 class="fb-label">' + esc(l.similar) + '</h3><div class="fb-sim">' + close.map(function (c) {
          return '<button type="button" class="fb-sim__item" data-fb-open="' + esc(c.p.handle) + '">' +
            (c.score != null ? '<b>' + c.score + '%</b>' : '') + '<span>' + esc(c.p.title) + '</span></button>';
        }).join('') + '</div>';
      }
    }

    var sizes = '';
    if (p.variants.length > 1 || (p.variants[0] && !/default/i.test(p.variants[0].title))) {
      sizes = '<div class="fb-sizes" role="radiogroup" aria-label="' + esc(l.size) + '">' + p.variants.map(function (v) {
        var sp = sizeParts(v.title);
        var on = !!(view.variant && view.variant.id === v.id);
        return '<button type="button" role="radio" class="fb-size' + (on ? ' is-on' : '') + (v.available ? '' : ' is-out') + '" aria-checked="' + on + '" data-fb-variant="' + v.id + '">' +
          '<span class="fb-size__n">' + esc(sp.num) + (sp.unit ? '<small>' + esc(sp.unit) + '</small>' : '') + '</span>' +
          '<span class="fb-size__p">' + (v.compare > v.price ? '<s>' + esc(self.money(v.compare)) + '</s> ' : '') + esc(self.money(v.price)) + '</span>' +
          (v.available ? '' : '<span class="fb-size__out">' + esc(l.soldout) + '</span>') +
        '</button>';
      }).join('') + '</div>';
    }

    var media = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.imageAlt) + '" decoding="async">' : '';

    return (
      (inline ? '' :
        '<div class="fb-sheet__grip" data-fb-drag aria-hidden="true"><span></span></div>' +
        '<button type="button" class="fb-sheet__close" data-fb-close aria-label="' + esc(l.close) + '">' + ICON_CLOSE + '</button>') +
      '<div class="fb-sheet__scroll">' +
        '<div class="fb-sheet__media">' + media + '</div>' +
        '<div class="fb-sheet__body">' +
          (p.inspired ? '<p class="fb-eyebrow">' + esc(l.inspired ? l.inspired + ' ' : '') + esc(p.inspired) + '</p>' : '') +
          '<h2 class="fb-sheet__title">' + esc(p.title) + '</h2>' +
          (pills ? '<div class="fb-pills">' + pills + '</div>' : '') +
          (meters ? '<div class="fb-meters">' + meters + '</div>' : '') +
          pyramid +
          similar +
          sizes +
          '<div class="fb-about" data-fb-about hidden></div>' +
          '<a class="fb-link" href="' + esc(p.url) + '">' + esc(l.details) + ICON_ARROW + '</a>' +
        '</div>' +
      '</div>' +
      '<div class="fb-sheet__bar">' +
        '<div class="fb-qty">' +
          '<button type="button" data-fb-qty="-1" aria-label="-">&minus;</button>' +
          '<span data-fb-qty-val>1</span>' +
          '<button type="button" data-fb-qty="1" aria-label="+">+</button>' +
        '</div>' +
        '<button type="button" class="fb-add" data-fb-add></button>' +
      '</div>'
    );
  };

  /* Live data (availability, description) for a product, shared by every view showing it. */
  Boutique.prototype.loadDetails = function (p) {
    var self = this;
    var refresh = function () {
      self.views.forEach(function (v) { if (v.product === p) v.refresh(); });
    };
    if (p.details) { refresh(); return; }
    if (p.loading) return;
    p.loading = true;
    fetch(p.url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        p.loading = false;
        if (!data) return;
        p.details = { description: data.description || '' };
        (data.variants || []).forEach(function (lv) {
          var v = p.variants.filter(function (x) { return x.id === lv.id; })[0];
          if (v) { v.available = !!lv.available; v.price = lv.price; v.compare = lv.compare_at_price || 0; }
        });
        p.available = p.variants.some(function (v) { return v.available; });
        refresh();
      })
      .catch(function () { p.loading = false; });
  };

  /* --------------------------------------------------------------- sheet */

  Boutique.prototype.onHash = function () {
    var m = window.location.hash.match(/^#p\/([^/?#]+)/);
    if (m) {
      var handle = decodeURIComponent(m[1]);
      if (this.byHandle.has(handle)) this.show(handle);
    } else if (this.dialog && this.dialog.open) {
      this.hide();
    }
  };

  Boutique.prototype.open = function (handle) {
    if (!this.byHandle.has(handle)) return;
    if (this.dialog && this.dialog.open) {
      history.replaceState(history.state, '', '#p/' + encodeURIComponent(handle));
      this.show(handle);
      return;
    }
    this.openedHere = true;
    window.location.hash = 'p/' + encodeURIComponent(handle);
  };

  Boutique.prototype.close = function () {
    if (this.openedHere && /^#p\//.test(window.location.hash)) {
      this.openedHere = false;
      history.back();
    } else {
      history.replaceState(history.state, '', window.location.pathname + window.location.search);
      this.hide();
    }
  };

  Boutique.prototype.show = function (handle) {
    var p = this.byHandle.get(handle);
    if (!p || !this.dialog || !this.sheetView) return;
    this.sheetView.render(p);
    var scroller = $('.fb-sheet__scroll', this.panel);
    if (scroller) scroller.scrollTop = 0;
    if (!this.dialog.open) {
      this.lastFocus = document.activeElement;
      this.dialog.showModal();
      this.panel.setAttribute('tabindex', '-1');
      this.panel.focus({ preventScroll: true });
      document.documentElement.classList.add('fb-lock');
      var dialog = this.dialog;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { dialog.classList.add('is-in'); });
      });
    }
  };

  Boutique.prototype.hide = function () {
    var dialog = this.dialog;
    if (!dialog || !dialog.open) return;
    var self = this;
    var timer;
    dialog.classList.remove('is-in');
    this.panel.style.transform = '';
    var onEnd = function (e) { if (e.target === self.panel) done(); };
    var done = function () {
      dialog.removeEventListener('transitionend', onEnd);
      clearTimeout(timer);
      if (dialog.open) dialog.close();
      document.documentElement.classList.remove('fb-lock');
      if (self.lastFocus && self.lastFocus.focus) {
        try { self.lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
    };
    timer = setTimeout(done, 400);
    dialog.addEventListener('transitionend', onEnd);
  };

  Boutique.prototype.updateCartCount = function (count) {
    $$('.cart-count-bubble span, [data-cart-count]').forEach(function (el) {
      if (!el.children.length) el.textContent = count;
    });
  };

  Boutique.prototype.toast = function () {
    var el = $('[data-fb-toast]', this.root);
    if (!el) return;
    var l = this.l;
    el.innerHTML = '<span>' + esc(l.added) + '</span><a href="' + esc(this.cfg.cart || '/cart') + '">' + esc(l.viewBag) + '</a><a href="/checkout" class="is-solid">' + esc(l.checkout) + '</a>';
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(function () {
      el.classList.remove('is-in');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 4500);
  };

  /* Drag the sheet down to close (touch screens). */
  Boutique.prototype.bindDrag = function () {
    var self = this;
    var panel = this.panel;
    var startY = null;
    var delta = 0;
    panel.addEventListener('touchstart', function (e) {
      var grip = e.target.closest('[data-fb-drag]');
      var scroller = $('.fb-sheet__scroll', panel);
      var atTop = !scroller || scroller.scrollTop <= 0;
      if (!grip && !(atTop && e.target.closest('.fb-sheet__media'))) return;
      startY = e.touches[0].clientY;
      delta = 0;
      panel.style.transition = 'none';
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      delta = Math.max(0, e.touches[0].clientY - startY);
      panel.style.transform = 'translateY(' + delta + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (startY === null) return;
      panel.style.transition = '';
      startY = null;
      if (delta > 110) self.close();
      else panel.style.transform = '';
    });
  };

  /* ============================================================== bootstrap */

  var instances = new Map();

  function initAll() {
    $$('[data-fb]').forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, new Boutique(root));
    });
  }

  window.FragranceBoutique = { initAll: initAll, instances: instances, noteImageError: noteImageError };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function () { initAll(); });
  document.addEventListener('shopify:section:unload', function (e) {
    instances.forEach(function (inst, root) {
      if (e.target.contains(root)) {
        inst.destroy();
        instances.delete(root);
      }
    });
  });
})();
